"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  "use strict";

  var TZ = "Europe/Paris";
  var DAY_LABELS = ["L", "M", "M", "J", "V", "S", "D"];

  // Le sélecteur de date de l'app travaille sur des Date : conversion à l'ouverture et à l'enregistrement.
  var toForm = function toForm(plage) {
    plage.untilDate = plage.until ? moment(plage.until, "YYYY-MM-DD").toDate() : null;
    return plage;
  };
  var fromForm = function fromForm(plage) {
    plage.until = plage.untilDate ? moment(plage.untilDate).format("YYYY-MM-DD") : "";
  };

  // Champs comparés pour savoir si une plage a été modifiée.
  var snapshot = function snapshot(plage) {
    return JSON.stringify([plage.weekdays.slice().sort(), plage.startTime, plage.endTime, plage.until]);
  };

  var Controller = function () {
    /** @ngInject */
    function Controller($rootScope, $scope, $timeout, SchedulesService, ScheduleRules) {
      _classCallCheck(this, Controller);

      this.$rootScope = $rootScope;
      this.$scope = $scope;
      this.$timeout = $timeout;
      this.SchedulesService = SchedulesService;
      this.ScheduleRules = ScheduleRules;
      this.dayLabels = DAY_LABELS;
    }

    _createClass(Controller, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;

        var params = this.resolve.params;
        this.operator = params.operator;
        this.today = moment().tz(TZ).format("YYYY-MM-DD");
        this.plages = [];
        this.complex = [];
        this.removedIds = [];
        this.fromDays = {};
        this.schedulesById = {};

        params.schedules.filter(function (schedule) {
          return _this.ScheduleRules.isCurrent(schedule, _this.today);
        }).forEach(function (schedule) {
          _this.schedulesById[schedule._id] = schedule;
          var plage = _this.ScheduleRules.parse(schedule);
          if (plage) {
            plage.original = snapshot(plage);
            _this.fromDays[plage.id] = moment(schedule.fromDate).tz(TZ).format("YYYY-MM-DD");
            _this.plages.push(toForm(plage));
          } else {
            _this.complex.push(schedule);
          }
        });
        this.sortPlages();
      }
    }, {
      key: "operatorName",
      value: function operatorName() {
        return ((this.operator.firstName || "") + " " + (this.operator.lastName || "")).trim();
      }
    }, {
      key: "sortPlages",
      value: function sortPlages() {
        this.plages.sort(function (a, b) {
          return (a.startTime || "").localeCompare(b.startTime || "");
        });
      }
    }, {
      key: "complexLabel",
      value: function complexLabel(schedule) {
        var when = schedule.rrule && schedule.rrule.description ? schedule.rrule.description : "Le " + moment(schedule.fromDate).tz(TZ).format("DD/MM/YYYY");
        return when + ", " + schedule.startTime + " - " + schedule.endTime;
      }
    }, {
      key: "hasCustomers",
      value: function hasCustomers(schedule) {
        return !!(schedule && schedule.enabledCustomersId && schedule.enabledCustomersId.length);
      }
    }, {
      key: "toggleDay",
      value: function toggleDay(plage, day) {
        var index = plage.weekdays.indexOf(day);
        if (index > -1) plage.weekdays.splice(index, 1);else plage.weekdays.push(day);
      }
    }, {
      key: "addPlage",
      value: function addPlage() {
        this.plages.push(toForm({ id: null, weekdays: [0, 1, 2, 3, 4], startTime: "09:00", endTime: "17:00", until: "", enabledCustomersId: [], name: "", note: "" }));
      }
    }, {
      key: "removePlage",
      value: function removePlage(plage) {
        if (plage.id) this.removedIds.push(plage.id);
        this.plages.splice(this.plages.indexOf(plage), 1);
      }
    }, {
      key: "customersLabel",
      value: function customersLabel(plage) {
        var count = plage.enabledCustomersId.length;
        if (!count) return "Tous les clients";
        return count + (count > 1 ? " clients autorisés" : " client autorisé");
      }

      // Le planning ouvre l'ancien formulaire complet pour les cas non gérés ici (récurrence complexe, clients autorisés).

    }, {
      key: "openFullForm",
      value: function openFullForm(schedule) {
        this.$scope.$parent.$close({ fullFormId: schedule._id });
      }
    }, {
      key: "close",
      value: function close(saved) {
        if (saved) this.$scope.$parent.$close({ saved: true });else this.$scope.$parent.$dismiss();
      }
    }, {
      key: "save",
      value: function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _plage2, error, created, updated, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, id, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, plage, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, _plage;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _iteratorNormalCompletion = true;
                  _didIteratorError = false;
                  _iteratorError = undefined;
                  _context.prev = 3;
                  _iterator = this.plages[Symbol.iterator]();

                case 5:
                  if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                    _context.next = 15;
                    break;
                  }

                  _plage2 = _step.value;

                  fromForm(_plage2);
                  error = this.ScheduleRules.validate(_plage2);

                  if (!error) {
                    _context.next = 12;
                    break;
                  }

                  Notiflix.Notify.failure(error);
                  return _context.abrupt("return");

                case 12:
                  _iteratorNormalCompletion = true;
                  _context.next = 5;
                  break;

                case 15:
                  _context.next = 21;
                  break;

                case 17:
                  _context.prev = 17;
                  _context.t0 = _context["catch"](3);
                  _didIteratorError = true;
                  _iteratorError = _context.t0;

                case 21:
                  _context.prev = 21;
                  _context.prev = 22;

                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }

                case 24:
                  _context.prev = 24;

                  if (!_didIteratorError) {
                    _context.next = 27;
                    break;
                  }

                  throw _iteratorError;

                case 27:
                  return _context.finish(24);

                case 28:
                  return _context.finish(21);

                case 29:
                  created = this.plages.filter(function (plage) {
                    return !plage.id;
                  });
                  updated = this.plages.filter(function (plage) {
                    return plage.id && snapshot(plage) !== plage.original;
                  });

                  if (!(!created.length && !updated.length && !this.removedIds.length)) {
                    _context.next = 34;
                    break;
                  }

                  this.close();
                  return _context.abrupt("return");

                case 34:

                  Notiflix.Loading.standard("Enregistrement...");
                  _context.prev = 35;
                  _iteratorNormalCompletion2 = true;
                  _didIteratorError2 = false;
                  _iteratorError2 = undefined;
                  _context.prev = 39;
                  _iterator2 = this.removedIds[Symbol.iterator]();

                case 41:
                  if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                    _context.next = 48;
                    break;
                  }

                  id = _step2.value;
                  _context.next = 45;
                  return this.SchedulesService.deleteById(id);

                case 45:
                  _iteratorNormalCompletion2 = true;
                  _context.next = 41;
                  break;

                case 48:
                  _context.next = 54;
                  break;

                case 50:
                  _context.prev = 50;
                  _context.t1 = _context["catch"](39);
                  _didIteratorError2 = true;
                  _iteratorError2 = _context.t1;

                case 54:
                  _context.prev = 54;
                  _context.prev = 55;

                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }

                case 57:
                  _context.prev = 57;

                  if (!_didIteratorError2) {
                    _context.next = 60;
                    break;
                  }

                  throw _iteratorError2;

                case 60:
                  return _context.finish(57);

                case 61:
                  return _context.finish(54);

                case 62:
                  _iteratorNormalCompletion3 = true;
                  _didIteratorError3 = false;
                  _iteratorError3 = undefined;
                  _context.prev = 65;
                  _iterator3 = updated[Symbol.iterator]();

                case 67:
                  if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                    _context.next = 74;
                    break;
                  }

                  plage = _step3.value;
                  _context.next = 71;
                  return this.SchedulesService.customPatch("updateOne", {
                    filters: { _id: plage.id },
                    vals: this.ScheduleRules.toVals(plage, this.fromDays[plage.id])
                  });

                case 71:
                  _iteratorNormalCompletion3 = true;
                  _context.next = 67;
                  break;

                case 74:
                  _context.next = 80;
                  break;

                case 76:
                  _context.prev = 76;
                  _context.t2 = _context["catch"](65);
                  _didIteratorError3 = true;
                  _iteratorError3 = _context.t2;

                case 80:
                  _context.prev = 80;
                  _context.prev = 81;

                  if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                  }

                case 83:
                  _context.prev = 83;

                  if (!_didIteratorError3) {
                    _context.next = 86;
                    break;
                  }

                  throw _iteratorError3;

                case 86:
                  return _context.finish(83);

                case 87:
                  return _context.finish(80);

                case 88:
                  _iteratorNormalCompletion4 = true;
                  _didIteratorError4 = false;
                  _iteratorError4 = undefined;
                  _context.prev = 91;
                  _iterator4 = created[Symbol.iterator]();

                case 93:
                  if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                    _context.next = 100;
                    break;
                  }

                  _plage = _step4.value;
                  _context.next = 97;
                  return this.SchedulesService.customPost("createOne", Object.assign(this.ScheduleRules.toVals(_plage, this.today), {
                    userId: "$" + this.operator._id.replace(/^\$/, ""),
                    customerId: this.$rootScope.$selectedCustomerId,
                    enabledCustomersId: _plage.enabledCustomersId,
                    name: _plage.name,
                    note: _plage.note
                  }));

                case 97:
                  _iteratorNormalCompletion4 = true;
                  _context.next = 93;
                  break;

                case 100:
                  _context.next = 106;
                  break;

                case 102:
                  _context.prev = 102;
                  _context.t3 = _context["catch"](91);
                  _didIteratorError4 = true;
                  _iteratorError4 = _context.t3;

                case 106:
                  _context.prev = 106;
                  _context.prev = 107;

                  if (!_iteratorNormalCompletion4 && _iterator4.return) {
                    _iterator4.return();
                  }

                case 109:
                  _context.prev = 109;

                  if (!_didIteratorError4) {
                    _context.next = 112;
                    break;
                  }

                  throw _iteratorError4;

                case 112:
                  return _context.finish(109);

                case 113:
                  return _context.finish(106);

                case 114:
                  Notiflix.Notify.success("Horaires enregistrés.");
                  this.close(true);
                  _context.next = 123;
                  break;

                case 118:
                  _context.prev = 118;
                  _context.t4 = _context["catch"](35);

                  console.error(_context.t4);
                  // Une partie a pu être enregistrée : on recharge pour afficher l'état réel.
                  Notiflix.Notify.failure("Erreur pendant l'enregistrement des horaires.");
                  this.close(true);

                case 123:
                  _context.prev = 123;

                  Notiflix.Loading.remove();
                  this.$timeout(function () {}, 0);
                  return _context.finish(123);

                case 127:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this, [[3, 17, 21, 29], [22,, 24, 28], [35, 118, 123, 127], [39, 50, 54, 62], [55,, 57, 61], [65, 76, 80, 88], [81,, 83, 87], [91, 102, 106, 114], [107,, 109, 113]]);
        }));

        function save() {
          return _ref.apply(this, arguments);
        }

        return save;
      }()
    }]);

    return Controller;
  }();

  angular.module("schedules.planning").component("operatorSchedules", {
    templateUrl: "app/pages/schedules/planning/operatorSchedules.html",
    bindings: { resolve: "<?" },
    controller: Controller
  });
})();